// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2i9YO","row":"styles_row__2S1X3"};